import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
import { CtaButton } from "./CtaButton";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-93" data-mp="1gj3lzs3ul3pf">
      <div className="mx-auto max-w-3xl" data-id="element-94" data-mp="1glpvvye7nvat">
        <h2 className="text-center font-serif text-[30px] font-black leading-tight text-ink sm:text-5xl" data-id="element-95" data-mp="248xyg8k98q95">Frequently asked questions</h2>

        <div className="mt-10 divide-y divide-ink/10 border-y border-ink/10" data-id="element-96" data-mp="28a9ogf71jdhv">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-97" data-mp="1zhfynntywvpr" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-98" data-mp="1zgn19dgwfika">
                  <span className="text-[17px] font-bold text-ink" data-id="element-99" data-mp="10tysub49za35">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-gold text-ink" : "bg-cream text-ink"}`} data-id="element-100" data-mp="10rvsoy9es0kp">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="1oj1b9l6qh6yp" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-102" data-mp="1jkzs709b57n8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-103" data-mp="1xkhhrhufgoxn">
                      <p className="pb-5 pr-10 text-[16px] leading-relaxed text-ink/75" data-id="element-104" data-mp="3uecdcfegufl6">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-12" data-id="element-105" data-mp="286rdxb2sudum">
          <CtaButton label="I’m ready — give me access" data-id="element-106" data-mp="285pqe74ljyw0" />
        </div>
      </div>
    </section>;
}